// Environment Configuration
// This file manages production and development database connections

const environments = {
  production: {
    supabaseUrl: 'https://dmnsynbxftuqmubdnhgw.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRtbnN5bmJ4ZnR1cW11YmRuaGd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzMDgyMTMsImV4cCI6MjA3NTg4NDIxM30.9AgTlIKIoh-1Kt8BqTZWxsnav4WuWhpQF0i_JBVzLgo',
  },
  development: {
    supabaseUrl: 'https://amnuavqnezqtsbnvdpge.supabase.co',
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFtbnVhdnFuZXpxdHNibnZkcGdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMzNTk0MzcsImV4cCI6MjA3ODkzNTQzN30.Rw5rXwe12c8rQx3plbmsGVMRmEt84wetRpPdxRMM7bU',
  }
};

// Change this value to switch environments
// 'production' or 'development'
//const ACTIVE_ENV = 'development';
const ACTIVE_ENV = 'production';

// Export the active configuration
export const config = environments[ACTIVE_ENV];
export const currentEnvironment = ACTIVE_ENV;

// Log which environment is active (helpful for debugging)
console.log(`🔧 Active Environment: ${ACTIVE_ENV}`);
console.log(`🔗 Supabase URL: ${config.supabaseUrl}`);
